import { __extends } from "tslib";
import * as React from 'react';
import { Slider as ExternalSlider, Rail, Handles, Tracks, } from 'react-compound-slider';
import { RailComponent, HandleComponent, TrackComponent } from './components';
import { namespacedClassnames } from '../../common';
export var sliderKey = 'slider';
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.defaultDomain = [0, 100];
        _this.onUpdate = function (update) {
            if (_this.props.onUpdate) {
                _this.props.onUpdate(update);
            }
        };
        _this.getDomain = function () { return _this.props.domain || _this.defaultDomain; };
        _this.renderHandles = function (_a) {
            var handles = _a.handles, getHandleProps = _a.getHandleProps;
            var handleItems = handles.map(function (handle) { return (React.createElement(HandleComponent, { key: handle.id, handle: handle, domain: _this.getDomain(), getHandleProps: getHandleProps, disabled: _this.props.disabled, tooltipRenderer: _this.props.tooltipRenderer })); });
            return React.createElement("div", { className: 'slider-handles' }, handleItems);
        };
        _this.renderTracks = function (_a) {
            var tracks = _a.tracks, getTrackProps = _a.getTrackProps;
            var trackItems = tracks.map(function (_a) {
                var id = _a.id, source = _a.source, target = _a.target;
                return (React.createElement(TrackComponent, { key: id, source: source, target: target, getTrackProps: getTrackProps, disabled: _this.props.disabled }));
            });
            return (React.createElement("div", { className: 'slider-tracks' }, trackItems));
        };
        _this.renderRail = function (_a) {
            var getRailProps = _a.getRailProps;
            return React.createElement(RailComponent, { getRailProps: getRailProps, disabled: _this.props.disabled });
        };
        return _this;
    }
    Slider.prototype.render = function () {
        var _a = this.props, values = _a.values, onChange = _a.onChange;
        var onUpdate = this.onUpdate;
        var classNames = namespacedClassnames(sliderKey, this.props.className);
        return (React.createElement("div", { className: classNames },
            React.createElement(ExternalSlider, { mode: 2, step: 1, domain: this.getDomain(), rootStyle: { position: 'relative', width: '100%' }, onUpdate: onUpdate, onChange: onChange, values: values, disabled: this.props.disabled },
                React.createElement(Rail, null, this.renderRail),
                React.createElement(Handles, null, this.renderHandles),
                React.createElement(Tracks, { left: this.props.values.length === 1, right: false }, this.renderTracks))));
    };
    return Slider;
}(React.PureComponent));
export { Slider };
//# sourceMappingURL=index.js.map